import { render, staticRenderFns } from "./question-box.vue?vue&type=template&id=3b3d3c56&scoped=true"
import script from "./question-box.vue?vue&type=script&lang=js"
export * from "./question-box.vue?vue&type=script&lang=js"
import style0 from "./question-box.vue?vue&type=style&index=0&id=3b3d3c56&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3d3c56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/AI合规前端-测试/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b3d3c56')) {
      api.createRecord('3b3d3c56', component.options)
    } else {
      api.reload('3b3d3c56', component.options)
    }
    module.hot.accept("./question-box.vue?vue&type=template&id=3b3d3c56&scoped=true", function () {
      api.rerender('3b3d3c56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/compliance/home/chat/question-box.vue"
export default component.exports